
import { Component, OnInit, ViewChild, Input, ElementRef, AfterViewInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { configuration } from '../../environments/config';
import { MatSidenavContent, MatSidenavModule } from '@angular/material/sidenav';
import { first, forkJoin } from 'rxjs';
import { GetJsonObjectService } from '../shared/services/get-json-object.service';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { PrimeNgArrayD4Component } from '../shared/prime-ng-array-d4/prime-ng-array-d4.component';
import { MaterialModule } from '../material-module';
import { columnDefinition, twoLinesDisplay } from '../shared/prime-ng-array-d4/prime-ng-array-d4.service';
import { environment } from '../../environments/environment';
import { deviceService } from '../shared/servicesHardware/deviceService';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, MatSidenavModule, MatProgressSpinnerModule, MatIconModule, PrimeNgArrayD4Component, MaterialModule, RouterModule],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {

  public orders: any[] = [];
  public invoices: any[] = [];
  public ordersColumnsDefinition: columnDefinition[] = [];
  public invoicesColumnsDefinition: columnDefinition[] = []
  public enumState: { value: any; displayValue: string }[] = []// configuration.appelASupport.enumEtatAvancement;
  public loading: boolean = false;
  private dowloadImgB64: string = "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAtOTYwIDk2MCA5NjAiIHdpZHRoPSIyNHB4IiBmaWxsPSIjMDAwMDAwIj48cGF0aCBkPSJNNDgwLTMyMCAyODAtNTIwbDU2LTU4IDEwNCAxMDR2LTMyNmg4MHYzMjZsMTA0LTEwNCA1NiA1OC0yMDAgMjAwWk0yNDAtMTYwcS0zMyAwLTU2LjUtMjMuNVQxNjAtMjQwdi0xMjBoODB2MTIwaDQ4MHYtMTIwaDgwdjEyMHEwIDMzLTIzLjUgNTYuNVQ3MjAtMTYwSDI0MFoiLz48L3N2Zz4="


  constructor(private getJsonObjectService: GetJsonObjectService, private deviceService: deviceService) {
    // this.initialiseColCommandes(configuration.commandes.labels);
    this.enumState =
      [
        { value: 0, displayValue: "En cours" },
        { value: 1, displayValue: "En cours" },
        { value: 2, displayValue: "En cours" },
        { value: 3, displayValue: "Validé, à cloturer" }
      ]

    this.getDatas();
    this.ordersColumnsDefinition = [
      { displayName: "Commande", name: "orderNumber", readOnly: true, ngStyle: { 'flex.px': '0 0 150' }, type: 'string', enum: null, drop: null, localFilter: false },
      { displayName: "Libellé", name: "orderDescription", readOnly: true, ngStyle: { 'flex.px': '0 0 400' }, type: 'string', enum: null, drop: null, localFilter: false },
      { displayName: "Société", name: "subscriberName", readOnly: true, ngStyle: { 'flex.px': '0 0 150' }, type: 'string', enum: null, drop: null, localFilter: false },
      { displayName: "Date", name: "orderDate", readOnly: true, ngStyle: { 'flex.px': '0 0 130' }, type: 'date', enum: null, drop: null, localFilter: false },
      {
        displayName: "Temps prévu", name: "totalWork", readOnly: true, ngStyle: { 'flex.px': '0 0 130' }, type: 'duration', enum: null, drop: null, localFilter: false,
        printLine: {
          methodImplementation: (object) => {
            if (object?.totalWork != null) {
              let returnValue: twoLinesDisplay = {
                topLine: '<span style="text-align: right">' + (object.totalWork / 3600).toFixed(2) + " h" + '</span>',
                bottomLine: ""
              }
              return returnValue
            }
            else {
              let returnValue: twoLinesDisplay = {
                topLine: '<span style="text-align: right"> </span>',
                bottomLine: ""
              }
              return returnValue
            }
          }
        },
      },
      {
        displayName: "Temps", name: "totalWork", readOnly: true, ngStyle: { 'flex.px': '0 0 130' }, type: 'duration', enum: null, drop: null, localFilter: false,
        printLine: {
          methodImplementation: (object) => {
            if (object?.remainingWork != null) {
              let remainingWorkStr = "";
              if (object.remainingWork >= 0)
                remainingWorkStr = '<span style="text-align: right">' + (object.remainingWork / 3600).toFixed(2) + " h restant </span>";
              else {
                remainingWorkStr = '<span style="text-align: right ; color : red">' + Math.abs((object.remainingWork / 3600)).toFixed(2) + " h en dépassement</span>";
              }

              let returnValue: twoLinesDisplay = {
                topLine: remainingWorkStr,
                bottomLine: ""
              }
              return returnValue
            }
            else {
              let returnValue: twoLinesDisplay = {
                topLine: '<span style="text-align: right"> </span>',
                bottomLine: ""
              }
              return returnValue
            }
          }
        },
      },
      {
        displayName: "Télécharger", name: "download", readOnly: true, ngStyle: { 'flex.px': '1 0 80', 'cursor': 'pointer' }, type: 'link', enum: null, drop: null, localFilter: false,
        printLine: {
          methodImplementation: (object) => {
            if (object?.download != null) {
              let returnValue: twoLinesDisplay = {
                topLine: ' <img style="cursor: pointer;" src="data:image/svg+xml;base64,' + this.dowloadImgB64 + '" />',
                bottomLine: ""
              }
              return returnValue
            }
            else {
              let returnValue: twoLinesDisplay = {
                topLine: '<span style="text-align: right"> </span>',
                bottomLine: ""
              }
              return returnValue
            }
          }
        },
      },
    ];
    this.invoicesColumnsDefinition = [
      { displayName: "Facture", name: "invoiceNumber", readOnly: true, ngStyle: { 'flex.px': '0 0 150' }, type: 'string', enum: null, drop: null, localFilter: false },
      { displayName: "Libellé", name: "invoiceDescription", readOnly: true, ngStyle: { 'flex.px': '0 0 400' }, type: 'string', enum: null, drop: null, localFilter: false },
      { displayName: "Société", name: "subscriberName", readOnly: true, ngStyle: { 'flex.px': '0 0 150' }, type: 'string', enum: null, drop: null, localFilter: false },
      { displayName: "Date", name: "issueDate", readOnly: true, ngStyle: { 'flex.px': '0 0 130' }, type: 'date', enum: null, drop: null, localFilter: false },
      { displayName: "Montant TTC", name: "totalAmount", readOnly: true, ngStyle: { 'flex.px': '0 0 130' }, type: 'currency', enum: null, drop: null, localFilter: false },
      { displayName: "Échéance", name: "dueDate", readOnly: true, ngStyle: { 'flex.px': '0 0 130' }, type: 'date', enum: null, drop: null, localFilter: false },
      { displayName: "Restant dû", name: "outstandingBalance", readOnly: true, ngStyle: { 'flex.px': '0 0 130' }, type: 'currency', enum: null, drop: null, localFilter: false },
      {
        displayName: "Télécharger", name: "download", readOnly: true, ngStyle: { 'flex.px': '1 0 80', 'cursor': 'pointer' }, type: 'link', enum: null, drop: null, localFilter: false,
        printLine: {
          methodImplementation: (object) => {
            if (object?.download != null) {
              let returnValue: twoLinesDisplay = {
                topLine: ' <img style="cursor: pointer;" src="data:image/svg+xml;base64,' + this.dowloadImgB64 + '" />',
                bottomLine: ""
              }
              return returnValue
            }
            else {
              let returnValue: twoLinesDisplay = {
                topLine: '<span style="text-align: right"> </span>',
                bottomLine: ""
              }
              return returnValue
            }
          }
        },
      },
    ];
  }

  ngOnInit() { }


  public refresh() { this.orders = []; this.getDatas(); }

  private getDatas() {
    let getterObservable: any[] = [];
    getterObservable.push(this.getJsonObjectService.getJson("cm/orders", undefined, { 'm': 'recent' }));
    getterObservable.push(this.getJsonObjectService.getJson("cm/invoices", undefined, { 'm': 'due' }));
    getterObservable.push(this.getJsonObjectService.getJson("support/companies/my"));

    forkJoin(getterObservable).subscribe(
      (getterObservableResult: any) => {
        this.initialData(getterObservableResult[0], getterObservableResult[1], getterObservableResult[2]);
      }
    );
  }

  private initialData(orders: any[], invoices: any[], societyList: any[]) {
    if (Array.isArray(orders)) {
      orders.forEach(order => {
        if (societyList.find((society: any) => society.companyUniqueId == order.companyUniqueId) != null)
          order.subscriberName = societyList.find((society: any) => society.companyUniqueId == order.companyUniqueId).companyName;
        if (order?.documentFileSize > 0) {
          order.download = environment.url + "cm/orders/" + order.orderUniqueId + "/document?access_token=" + this.deviceService.decryptDataLocalStorage('userSession').currentUser;
        }
        order["id"] = order.orderUniqueId;
        this.orders.push(order);
      })
      invoices.forEach(invoice => {
        if (societyList.find((society: any) => society.companyUniqueId == invoice.companyUniqueId) != null)
          invoice.subscriberName = societyList.find((society: any) => society.companyUniqueId == invoice.companyUniqueId).companyName;
        if (invoice?.documentFileSize > 0) {
          invoice.download = environment.url + "cm/invoices/" + invoice.invoiceUniqueId + "/document?access_token=" + this.deviceService.decryptDataLocalStorage('userSession').currentUser;
        }
        invoice["id"] = invoice.invoiceUniqueId;
        this.invoices.push(invoice);
      })
    }
    this.loading = false;
  }


  public returnRowOrder(e: any, indiceName: string): any {
    if (e[indiceName] != null) {
      let strReturn: string = "";
      if (indiceName == "remainingWork") {
        if (e[indiceName] >= 0)
          strReturn = (e[indiceName] / 3600).toFixed(2) + " h restant";
        else
          strReturn = Math.abs((e[indiceName] / 3600)).toFixed(2) + " h en dépassement";
      }
      else if (typeof e[indiceName] == 'number')
        strReturn = (e[indiceName] / 3600).toFixed(2) + " h";
      else
        strReturn = e[indiceName];

      return strReturn;
    }
    else
      return "";
  }

  public encodeURIInvoice(doc: any): string {
    return encodeURI(environment.url + "cm/invoices/" + doc + "/document?access_token=" + this.deviceService.decryptDataLocalStorage('userSession').currentUser);
  }

  public encodeURIOrders(doc: any): string {
    return encodeURI(environment.url + "cm/orders/" + doc + "/document?access_token=" + this.deviceService.decryptDataLocalStorage('userSession').currentUser);
  }


}

export interface Iemployees {
  firstName: string,
  lastName: string,
  title: string,
  displayName: string,
  personUniqueid: string;
}
